var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.tableShow === "course" ? _c("courseTable", {
    on: {
      "child-go": _vm.goChild
    }
  }) : _vm._e(), _vm.tableShow === "courseClass" ? _c("courseClassTable", {
    attrs: {
      currentCourse: _vm.currentCourse
    },
    on: {
      "child-go-course": _vm.goCourse
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };